import IRequiredDocumentDetailCategory from "@/module/main/dto/IRequiredDocumentDetailCategory";
import IRequiredDocumentDetailType from "@/module/main/dto/IRequiredDocumentDetailType";
import RequiredDocumentDetailCategoryCode from "@/module/main/dto/RequiredDocumentDetailCategoryCodeEnum";

export class RequiredDocumentDetailCategory implements IRequiredDocumentDetailCategory
{
    constructor(
        public code: RequiredDocumentDetailCategoryCode,
        public documentTypes?: IRequiredDocumentDetailType[]
    )
    {
    }
}
